import { CartLabel, CartLabelMap } from '../ui/components/CartList'

export const getCartLabels = (
  groupBy: string | string[] = [],
  map: CartLabelMap = {}
): CartLabel => {
  const groupByArray = Array.isArray(groupBy) ? groupBy : [groupBy]
  const labelMap = groupByArray.map(
    (value) => map[value] || map[value.toLowerCase()] || { label: value }
  )
  const label = labelMap.map((value) => value.label).join(', ')
  const icon = labelMap.find((value) => value.icon)?.icon || map?.default?.icon
  return { icon, label }
}
